// generated file, if you want to edit this file manually change the word "generated" to "manual"
import React from "react";
import clsx from "clsx";
import { makeThemedStyles } from "./../utils";
import MaterialGrid from "@material-ui/core/Grid";
import { excludeKeys } from "./../utils";
import { useAppContext } from "./../../context/AppCtxProvider";
import { getFileApiURL as fileURL } from "./../../utils/url-utils";
import * as registry from "@qpr/client-api-registry";
const useStylesForPageContainer = makeThemedStyles(
  "PageContainer",
  (theme) => ({
    PageContainer: {
      height: "100vh",
      backgroundImage: `url(${registry.get("LandingPageBackground")})`,
      backgroundSize: "cover",
      backgroundRepeat: "no-repeat",
      backgroundPosition: "center",
      breakpoints: [
        [
          "only",
          "xs",
          {
            backgroundPosition: "60% 50%",
          },
        ],
      ],
    },
  })
);
type PropType = React.ComponentProps<typeof MaterialGrid>;
export const PageContainer: React.FunctionComponent<PropType> = (
  props: PropType
) => {
  const styles = useStylesForPageContainer();
  const rtl = useAppContext((s) => s.rtl);
  const enabledClasses = excludeKeys(styles, [
    "PageContainer",
    "SubPageContent",
    "SubPageContainer",
    "SubPageHeader",
    "PageContainerOverlay",
  ]);
  const containerStyle = rtl
    ? { backgroundImage: `url(${fileURL("/public/backgroundRTL.png")})` }
    : undefined;
  /* eslint-disable */
  return (
    <MaterialGrid
      {...props}
      classes={{
        root: styles.PageContainer,
        ...enabledClasses,
      }}
      className={clsx(styles.PageContainer)}
      style={containerStyle}
    >
      {props?.children}
    </MaterialGrid>
  );
};
export default PageContainer;
